import { Footnotes, Sup } from "./Footnotes";
import type { ConceptBlock } from "./model";
import { pad2 } from "./model";
import { SlideHeading } from "./SlideHeading";

export function ConceptSlide({ block }: { block: ConceptBlock }) {
  const lead = block.lead ? (
    <>
      {block.lead}
      <Sup refs={block.refs} />
    </>
  ) : undefined;
  return (
    <div className="slide">
      <SlideHeading blockId={block.id} title={block.title} lead={lead} />
      <div className="abs concept-body" style={{ top: block.lead ? 252 : 200 }}>
        {block.statement ? (
          <p className="statement" style={{ margin: 0 }}>
            {block.statement}
            {!block.lead && <Sup refs={block.refs} />}
          </p>
        ) : (
          block.bullets.length > 0 && (
            <ul className="bullets">
              {block.bullets.map((b, i) => (
                <li key={i} className="bullet">
                  <span className="bullet-key">{pad2(i + 1)}</span>
                  <span>
                    {b}
                    {!block.lead && i === block.bullets.length - 1 && <Sup refs={block.refs} />}
                  </span>
                </li>
              ))}
            </ul>
          )
        )}
      </div>
      <Footnotes refs={block.refs} />
    </div>
  );
}
